module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Submission History")]), _vm._v(" "), _c('p', {
    staticClass: "filters"
  }, [_vm._v("\n    Filter by status:\n    "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.setFilterStatus({})
      }
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((Object.keys(_vm.status)), function(st) {
    return _c('a', {
      on: {
        "click": function($event) {
          return _vm.setFilterStatus({
            key: 'status',
            value: _vm.status[st]
          })
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.status[st]))])
  })], 2), _vm._v(" "), _c('Table', {
    attrs: {
      "items": _vm.articleList,
      "columns": [
        'title',
        'term' ].concat( (['admin', 'god'].includes(_vm.role) ? ['author'] : []),
        ['status'],
        ['date'] ),
      "actions": _vm.actions[_vm.role],
      "filterField": _vm.filterStatus
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-082d3cda!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubmissionsList.vue
// module id = 159
// module chunks = 2